<template>
  <div class="c-navigation container mt--2 mb--3">
    <div class="c-navigation__content">
      <ul class="c-navigation__list">
        <li class="c-navigation__item c-navigation__item--completed">Marka</li>
        <li class="c-navigation__item" v-on:click="goToRoute('service')" v-bind:class="[
          { 'c-navigation__item--completed': validation.service == true },
          { 'c-navigation__item--current': this.$route.name == 'service' },
        ]">
          Usługa
        </li>
        <li class="c-navigation__item" v-on:click="goToRoute('visit')" v-bind:class="[
          { 'c-navigation__item--completed': validation.visit == true },
          { 'c-navigation__item--current': this.$route.name == 'visit' },
        ]">
          Wizyta
        </li>
        <li class="c-navigation__item" v-on:click="goToRoute('client')" v-bind:class="[
          { 'c-navigation__item--completed': validation.client == true },
          { 'c-navigation__item--current': this.$route.name == 'client' },
        ]">
          Klient
        </li>
        <li class="c-navigation__item" v-on:click="goToRoute('car')" v-bind:class="[
          { 'c-navigation__item--completed': validation.car == true },
          { 'c-navigation__item--current': this.$route.name == 'car' },
        ]">
          Pojazd
        </li>
        <li class="c-navigation__item" v-bind:class="[
          { 'c-navigation__item--completed': validation.overview == true },
          { 'c-navigation__item--current': this.$route.name == 'overview' },
        ]">
          Przegląd
        </li>
        <li class="c-navigation__item">Potwierdzenie</li>
      </ul>
    </div>
  </div>
</template>
<script>
import lead from "../mixins/lead.js";

export default {
  mixins: [lead],
  methods: {
    goToRoute(name) {
      if (this.validation[name]) {
        this.$router.push({ path: name });
      }
      return;
    },
  },
};
</script>
<style lang="scss">
.c-navigation {
  &__content {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__list {
    list-style-type: none;
    font-size: 1.25rem;
    max-width: 920px;
    width: 100%;
    display: flex;
    padding-left: 0;
  }

  &__item {
    text-align: center;
    border-bottom: 3px solid $darkgray;
    color: $darkgray;
    width: 100%;
    padding-bottom: 1rem;

    @media (max-width: 780px) {
      font-size: 1rem;
    }

    &--completed {
      border-bottom: 3px solid $blue;
      color: $blue;
      cursor: pointer;
    }

    &--current {
      border-bottom: 3px solid $orange;
      color: $orange;
    }
  }

  &__baner {
    max-width: 100%;
    margin: 0 auto;
    margin-top: 3rem;
  }

  &__promo {
    border: 1px solid $orange;
    padding: 1rem;
    text-align: center;
    margin-bottom: .5rem;

    h2 {
      font-size: 1.3rem;
    }
  }
}
</style>
